module.exports = __webpack_public_path__ + "img/expirations.15d6997f.svg";